import rehypeRaw from 'rehype-raw'
import rehypeSanitize from 'rehype-sanitize'
import rehypeStringify from 'rehype-stringify'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import { unified } from 'unified'
import { sanitizeSchema } from './markdownSanitizeSchema'

const processor = unified()
  .use(remarkParse)
  .use(remarkRehype, { allowDangerousHtml: true })
  .use(rehypeRaw)
  .use(rehypeSanitize, sanitizeSchema)
  .use(rehypeStringify)

/**
 * Synchronously parses markdown (allowing embedded raw HTML) and strips anything
 * unsafe, using the same sanitization schema as UiMarkdown. For call sites that
 * can't render the UiMarkdown component itself — e.g. content built via
 * ReactDOMServer.renderToString outside the app's React tree/Suspense boundaries,
 * such as the Mapbox popup tooltip.
 */
export const sanitizeMarkdownToHtml = (markdown: string): string =>
  String(processor.processSync(markdown))
